import React from 'react';
import classnames from 'classnames';
import Line from '../components/Line';

import { useBreakpoint, useWindowSize } from '../utils/hooks';
import { isBreakpoint } from '../utils';
import { SimpleContainer, SidesContainer } from '../components/Container';

import * as css from './CapsAndTech.module.css';
import * as grid from '../styles/grid.module.css';

const CapsAndTech = ({ title, frontmatter, id }) => {
  const [winWidth] = useWindowSize();
  const breakpoint = useBreakpoint(winWidth);
  const isReduced = isBreakpoint(breakpoint, 'reduced');
  const { capabilities, technology } = frontmatter;
  return (
    <div id="capabilities-technology">
      <SimpleContainer bottomLine className={css.beforeTitle}></SimpleContainer>

      <SimpleContainer className={css.title}>
        {capabilities && capabilities.length > 0 && (
          <div className={classnames(grid.col, css.left)}>
            <h2>Capabilities</h2>
          </div>
        )}
        {!isReduced && technology && technology.length > 0 && (
          <div className={classnames(grid.col, css.right)}>
            <h2>Technology</h2>
          </div>
        )}
      </SimpleContainer>
      <Line />
      <SidesContainer bottomLine className={css.content}>
        {capabilities && capabilities.length > 0 && (
          <div className={classnames(grid.col, css.left)}>
            <ul>
              {capabilities.map((child, i) => {
                return <li key={i}>{child}</li>;
              })}
            </ul>
          </div>
        )}
        {!isReduced && technology && technology.length > 0 && (
          <div className={classnames(grid.col, css.right)}>
            <ul>
              {technology.map((child, i) => {
                return <li key={i}>{child}</li>;
              })}
            </ul>
          </div>
        )}
      </SidesContainer>

      {isReduced && technology && technology.length > 0 && (
        <>
          <SimpleContainer className={css.title}>
            <div className={classnames(grid.col, css.left)}>
              <h2>Technology</h2>
            </div>
          </SimpleContainer>
          <Line />
          <SidesContainer bottomLine className={css.content}>
            <div className={classnames(grid.col, css.left)}>
              <ul>
                {technology.map((child, i) => {
                  return <li key={i}>{child}</li>;
                })}
              </ul>
            </div>
          </SidesContainer>
        </>
      )}
    </div>
  );
};

export default CapsAndTech;
